
import { PropType, ComputedRef, computed, defineComponent } from "vue";
import { formatOneTime, formattedDate, formattedDuration } from "../../mixins";
import { EventCourse } from "../../../../../domain/entities/courseEvent/courseEvent";
import NewContentEventFlag from "../flags/NewContentEventFlag.vue";
import SimpleModal from "../modals/SimpleModal.vue";
import ModalDataEvent from "./ModalData.vue";
import router from "@/routes";

const __default__ = defineComponent({
  name: "Card",
  methods: { formatOneTime },
  components: { SimpleModal, NewContentEventFlag, ModalDataEvent },
  props: {
    event: {
      type: Object as PropType<EventCourse>,
      required: true
    }
  },
  setup(props) {
    /** this computed image is used in <style> proprieties */
    const image: ComputedRef<string> = computed(() => {
      return props.event?.image
        ? `url(${props.event.image})`
        : "url('../../../assets/static/nothing-found.svg')";
    });

    const getBrazilianDateFormat = (date: string): string => {
      const [year, month, day] = date.split("-");
      if (!year || !month || !day) return "-";
      return `${day}/${month}/${year}`;
    };

    const formatDate = (startDate: string, endDate: string): string => {
      return startDate === endDate || !endDate
        ? getBrazilianDateFormat(startDate)
        : `${getBrazilianDateFormat(startDate)} até ${getBrazilianDateFormat(
            endDate
          )}`;
    };

    function redirect(): void {
      router.push({
        name: "event",
        params: {
          event_id: props.event.id,
          class_id: props.event.classes[0].id
        }
      });
    }

    return {
      image,
      redirect,
      formatDate,
      formattedDate,
      formattedDuration
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "92fa38a4": (_ctx.image)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__